import { useEffect } from 'react';
import {
  buildBreadcrumbListSchema,
  type BreadcrumbItem,
} from '../../utils/breadcrumbJsonLd';

const ATTR = 'data-social-trip-breadcrumb-jsonld';

type Props = { items: BreadcrumbItem[] };

/**
 * BreadcrumbList JSON-LD（パンくず）
 */
export default function BreadcrumbJsonLd({ items }: Props) {
  useEffect(() => {
    const json = buildBreadcrumbListSchema(items);
    const el = document.createElement('script');
    el.type = 'application/ld+json';
    el.setAttribute(ATTR, 'true');
    el.textContent = JSON.stringify(json).replace(/</g, '\\u003c');
    document.head.appendChild(el);
    return () => {
      document.head.querySelectorAll(`script[${ATTR}]`).forEach((n) => n.remove());
    };
  }, [items]);

  return null;
}
